export function mapFilters({
  moduleName,
  states,
  setMutation,
  setCallback = () => {},
}) {
  const res = {};
  states.forEach((state) => {
    res['filter' + state.charAt(0).toUpperCase() + state.slice(1)] = {
      get() {
        return this.$store.state[moduleName].filters[state];
      },
      set(value) {
        this.$store.commit(setMutation, { [state]: value });
        if (this[setCallback] && typeof this[setCallback] == 'function') {
          this[setCallback]();
        }
      },
    };
  });
  return res;
}

export function actionsToMutations(mutations) {
  const res = {};
  mutations.forEach((mutation) => {
    res[mutation] = ({ commit }, payload) => {
      commit(mutation, payload);
    };
  });
  return res;
}
